__turbopack_context__.v({
  "denomination": "mGDo4W_denomination",
  "rounded": "mGDo4W_rounded",
  "textInput": "mGDo4W_textInput",
  "textInputWrapper": "mGDo4W_textInputWrapper",
  "underlined": "mGDo4W_underlined",
});
